import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import { Text } from '@zillow/constellation';

const propTypes = {
    text: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired,
};

const TextLinkContent = ({
    text,
    href,
    cta,
}) => (
    <Text fontType="body">
        {text}
        <Link to={href}>{cta}</Link>
    </Text>
);

TextLinkContent.propTypes = propTypes;

export default TextLinkContent;
